import { printDailySchedule } from "@/pages/human-resources/time-management/endpoints/schedules/print/PrintScheduleEndpoints";
import useSchedulesManager from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useSchedulesManager.ts";
import useVisibleEmployeesSchedules from "@/pages/human-resources/time-management/model/schedule-view/useVisibleEmployeesSchedules.ts";
import useDisplayOptionsState from "@/pages/human-resources/time-management/model/display-options/useDisplayOptionsState.ts";
import useScheduleReferenceData from "@/pages/human-resources/time-management/schedules/reference-provider/useScheduleReferenceData.ts";
import { inputForPrintDailySchedule } from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/PrintDailyScheduleIn";
import useScheduleViewFilters from "@/pages/human-resources/time-management/components/display-filters/provider/useScheduleViewFilters.ts";

export default function usePrintDailyScheduleCells(): () => Promise<boolean> {
  const manager = useSchedulesManager();
  const schedules = useVisibleEmployeesSchedules();
  const displayOptions = useDisplayOptionsState();
  const { state: viewFilters } = useScheduleViewFilters();
  const referenceData = useScheduleReferenceData();
  const visibleTags = referenceData
    .listDailyTags()
    .filter((t) => !displayOptions.selectedDailyTags.shouldHide(t));

  return async (): Promise<boolean> => {
    try {
      const input = inputForPrintDailySchedule(
        manager.contractsManager.startDate,
        manager.contractsManager.endDate,
        manager.contractsManager.siteId,
        schedules.map((s) => s.employee.id),
        visibleTags,
        displayOptions,
        viewFilters,
      );
      await printDailySchedule(input);
      return true;
    } catch (error) {
      console.error("Failed to print schedule", error);
      return false;
    }
  };
}
